export const getScreenHeight = state => {
    return window.screen.height
}

export const getScreenWidth = state => {
    return window.screen.width
}

export const getMasterDB = state => {
    return state.db
}

export const getRefCompany = state => {
    return state.refCompany
}


// WEBPACK FOOTER //
// ./src/store/modules/master/getters.js